import styled from "styled-components";

export const FormFieldLabelRow = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
`;

export const OptionalLabel = styled.span`
  color: ${({ theme }) => theme.globalConstants.color.textTertiary};
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-size: 12px;
  font-style: italic;
  font-weight: 400;
  line-height: 1.5;
`;
